export default __webpack_public_path__ + "static/media/mb-resolved-check.48d1a399.svg";